import { useTranslation } from "react-i18next";
import type { FoundingAccountSummary } from "./types";

interface FoundingAccountsSummaryProps {
  readonly accounts: readonly FoundingAccountSummary[];
}

export function FoundingAccountsSummary({ accounts }: FoundingAccountsSummaryProps) {
  const { t } = useTranslation();
  if (accounts.length === 0) return null;

  return (
    <section aria-label={t("founding.accounts.title")} className="space-y-2">
      <h3 className="font-sans text-sm font-medium text-muted-foreground">
        {t("founding.accounts.title")}
      </h3>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {accounts.map((a) => (
          <div
            key={a.ownerId}
            data-testid={`founding-account-${a.ownerId}`}
            className="rounded-lg border border-border p-3"
          >
            <p className="font-sans text-sm font-medium">{a.ownerName}</p>
            <p className="font-sans text-xs text-muted-foreground">
              {t("founding.accounts.properties", { count: a.propertyCount })}
              {" · "}
              {t("founding.accounts.active", { count: a.activeFounderCount })}
            </p>
            <div className="mt-2 flex flex-wrap gap-1">
              {Object.entries(a.tierMix).map(([tier, n]) => (
                <span
                  key={tier}
                  className="rounded bg-muted px-1.5 py-0.5 font-sans text-xs text-muted-foreground"
                >
                  {tier}: {n}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
